import { generatePath, useHistory } from 'react-router-dom'
import {
  useNetworkHomeJobsRouteParams,
  useCurrentHomeSiteId,
} from 'features/networkAi/hooks'
import ROUTES from 'app/routes'
import { useIntl } from 'react-intl'
import { makePublicUrl } from 'app/utils/publicUrl'
import { H2 } from 'components/Typography'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import { NetworkClientsContainer, NetworkClientsHeader } from './styles'
import { NetworkAIBackButton, NetworkAIBackIcon } from '../styles'
import { network } from 'features/networkAi/messages'
import ClientsListView from './ClientsListView'

function NetworkClients() {
  const { formatMessage } = useIntl()
  const history = useHistory()
  const { rootDomainId, homeId, jobId } = useNetworkHomeJobsRouteParams()
  const siteId = useCurrentHomeSiteId({ homeId })

  const handleNavigateNetworkAIClick = () => {
    const pathname = generatePath(ROUTES.networkAi.dashboard.root, {
      rootDomainId,
      jobId,
      homeId,
      siteId,
    })
    history.push(pathname)
  }

  return (
    <StyledFadeInWrapper>
      <NetworkClientsContainer>
        <NetworkAIBackButton onClick={handleNavigateNetworkAIClick}>
          <NetworkAIBackIcon
            src={makePublicUrl(`images/networkIcons/arrow-back.svg`)}
          />
          {formatMessage(network.backNetworkAI)}
        </NetworkAIBackButton>

        <NetworkClientsHeader>
          <H2>{formatMessage(network.networkClients)}</H2>
        </NetworkClientsHeader>

        <ClientsListView siteId={siteId} />
      </NetworkClientsContainer>
    </StyledFadeInWrapper>
  )
}

export default NetworkClients
